import { useState } from 'react'
import { displayName, logoBadgeColor } from '../lib/format'

interface Props {
  company: string
  logo?: string | null
  size?: number
}

/**
 * Company mark. Tries the Clearbit logo captured at brief time and falls back to a coloured
 * initial. The prototype did this with an inline `onerror` handler that rewrote innerHTML;
 * here it is just state.
 */
export function Logo({ company, logo, size = 34 }: Props) {
  const [failed, setFailed] = useState(false)
  const name = displayName(company)

  if (!logo || failed) {
    return (
      <span
        className="logo-badge"
        style={{
          width: size,
          height: size,
          background: logoBadgeColor(name),
          fontSize: Math.round(size * 0.42),
        }}
      >
        {(name || '?').trim().charAt(0).toUpperCase()}
      </span>
    )
  }

  return (
    <span className="logo-wrap" style={{ width: size, height: size }}>
      <img
        src={logo}
        alt=""
        width={size}
        height={size}
        onError={() => setFailed(true)}
        style={{ width: size, height: size }}
      />
    </span>
  )
}
